import * as tslib_1 from "tslib";
import { ChangeDetectorRef, ViewContainerRef } from '@angular/core';
import { BooleanConverter, InputConverter, JSONConverter } from '../../../inputConverter';
import { AoiService } from '../../../services/aoi.service';
import { GisToolsService } from '../../../services/gis-tools.service';
import { Juris } from '../../../types';
import { BaseComponent } from '../../base.component';
var RouteComponent = /** @class */ (function (_super) {
    tslib_1.__extends(RouteComponent, _super);
    function RouteComponent(_vcr, gisToolsService, aoiService, cdr) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.gisToolsService = gisToolsService;
        _this.aoiService = aoiService;
        _this.cdr = cdr;
        _this.jurisSort = false;
        _this._jurisValues = [Juris.State, Juris.Turnpike, Juris.NonStateFederalAid, Juris.TollBridge]; // default juris values
        _this.defaultJurisSet = false;
        _this.jurisOptions = [
            { name: '', values: [Juris.State, Juris.Turnpike, Juris.NonStateFederalAid, Juris.TollBridge] },
            { name: 'State', values: [Juris.State] },
            { name: 'Non-State Federal Aid Roads', values: [Juris.NonStateFederalAid] }
        ];
        _this.jurisSortStr = '';
        _this.sortJurisFirst = false;
        _this.showFullName = false;
        _this.sortRouteBy = 'number';
        _this.hideRamps = false;
        _this.activate = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a, error_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.isActive) {
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        _a = this;
                        return [4 /*yield*/, this.gisToolsService.getAllCounties('countyCode, name', this.countySortField)];
                    case 2:
                        _a.counties = _b.sent();
                        this.cdr.detectChanges();
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _b.sent();
                        this.readyProblem(error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.isReady();
                        this.isActive = true;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.reset = function () {
            _this._county = null;
            _this._route = null;
            _this._segment = null;
            _this._offset = null;
            _this.segmentBegin = null;
            _this.segmentEnd = null;
        };
        _this.addResultToMap = function () {
            var searchCriteria = {
                type: 'route',
                title: "Route (" + _this.route.stateRouteNumber + ")",
                stateRouteNumber: _this.route.stateRouteNumber
            };
            if (_this.route.countyCode) {
                searchCriteria.title += "County (" + _this.route.countyCode + ")";
                searchCriteria.countyCode = _this.route.countyCode;
            }
            if (_this.segment) {
                searchCriteria.title = searchCriteria.title + " " + _this.segmentBegin + "-" + _this.segmentEnd;
                searchCriteria.segBgn = _this.segmentBegin;
                searchCriteria.segEnd = _this.segmentEnd;
            }
            if (_this.offset) {
                searchCriteria.title = searchCriteria.title + " " + _this.offset;
                searchCriteria.offset = _this.offset;
            }
            _this.aoiService.setSearchCriterias([searchCriteria]);
        };
        return _this;
    }
    Object.defineProperty(RouteComponent.prototype, "county", {
        get: function () {
            return this._county;
        },
        set: function (county) {
            this._county = county;
            this.filterRoutes();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RouteComponent.prototype, "route", {
        get: function () {
            return this._route;
        },
        set: function (route) {
            this._route = route;
            this.filterSegments(route);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RouteComponent.prototype, "segment", {
        get: function () {
            return this._segment;
        },
        set: function (segment) {
            var _this = this;
            this._segment = segment;
            if (segment) {
                this.segmentBegin = segment.segmentNumber;
                this.segmentEnd = segment.segmentNumber;
                this.segmentEnds = this.segmentBegins.filter(function (s) { return s.segmentNumber >= _this.segmentBegin; });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RouteComponent.prototype, "offset", {
        get: function () {
            return this._offset;
        },
        set: function (offset) {
            this._offset = offset;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RouteComponent.prototype, "jurisValues", {
        get: function () {
            return this._jurisValues;
        },
        set: function (value) {
            if (typeof (value) === 'string') {
                //convert comma separated string into number array
                var stringArr = value.split(',');
                value = stringArr.map(function (x) { return (parseInt(x, 10)); });
            }
            if (!this.defaultJurisSet) {
                this.jurisOptions.splice(0, 1, { name: '', values: value });
                this.defaultJurisSet = true;
            }
            if (value !== this.jurisOptions[0].values) {
                //when not default, add sort text, and sort routes by juris(& then selected sort)
                this.jurisSortStr = 'Juris, then';
                this.sortJurisFirst = true;
            }
            else {
                this.jurisSortStr = '';
                this.sortJurisFirst = false;
            }
            this._jurisValues = value;
            this.filterRoutes();
        },
        enumerable: true,
        configurable: true
    });
    RouteComponent.prototype.filterRoutes = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var propertyList, properties, _a, _b, error_2;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 5, , 6]);
                        propertyList = ['countyCode', 'stateRouteNumber'];
                        if (this.showFullName) {
                            propertyList.push('fullName');
                        }
                        properties = propertyList.join(', ');
                        if (!this.jurisValues) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.gisToolsService.getStateRoutesByCountyJuris(this.county.countyCode, this.jurisValues, properties + ", juris")];
                    case 1:
                        _a.stateRoutes = _c.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        _b = this;
                        return [4 /*yield*/, this.gisToolsService.getStateRoutesByCounty(this.county.countyCode, properties)];
                    case 3:
                        _b.stateRoutes = _c.sent();
                        _c.label = 4;
                    case 4:
                        this.filteredStateRoutes = this.stateRoutes.filter(function (r) { return r.countyCode === _this.county.countyCode; });
                        if (this.hideRamps) {
                            //remove 8000 and 9000 state routes from the results
                            this.filteredStateRoutes = this.filteredStateRoutes.filter(function (r) { return !(parseInt(r.stateRouteNumber, 10) >= 8000 && parseInt(r.stateRouteNumber, 10) <= 9999); });
                        }
                        this.filteredStateRoutes = this.filteredStateRoutes.map(function (r) {
                            r.displayText = r.stateRouteNumber;
                            if (r.fullName) {
                                r.displayText += " (" + r.fullName + ")";
                                if (r.displayText.length >= 100) {
                                    r.displayText = r.displayText.substring(0, 100) + "...";
                                }
                            }
                            return r;
                        });
                        this.route = null;
                        this.routeSortChange();
                        this.filteredStateRoutes.unshift({ name: '', stateRouteNumber: '' });
                        this.cdr.detectChanges();
                        return [3 /*break*/, 6];
                    case 5:
                        error_2 = _c.sent();
                        this.readyProblem(error_2);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    RouteComponent.prototype.filterSegments = function (route) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, error_3;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this;
                        return [4 /*yield*/, this.gisToolsService.getSegmentsByCountyAndRoute(this.county.countyCode, route.stateRouteNumber, 'countyCode, stateRouteNumber, segmentNumber')];
                    case 1:
                        _a.segments = _b.sent();
                        if (route) {
                            this.segmentBegins = this.segments.filter(function (s) {
                                return s.countyCode === route.countyCode && s.stateRouteNumber === route.stateRouteNumber && s.stateRouteNumber === route.stateRouteNumber;
                            });
                        }
                        this.segment = null;
                        this.cdr.detectChanges();
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _b.sent();
                        this.readyProblem(error_3);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RouteComponent.prototype.routeSortChange = function () {
        var _this = this;
        if (this.county) {
            //reorder strings then sort
            if (this.sortRouteBy === 'name') {
                this.filteredStateRoutes = this.filteredStateRoutes.map(function (r) {
                    r.displayText = r.fullName + " (" + r.stateRouteNumber + ")";
                    if (r.displayText.length >= 100) {
                        r.displayText = r.displayText.substring(0, 100) + "...";
                    }
                    return r;
                });
            }
            else if (this.sortRouteBy === 'number') {
                this.filteredStateRoutes = this.filteredStateRoutes.map(function (r) {
                    r.displayText = r.stateRouteNumber;
                    if (r.fullName) {
                        r.displayText += " (" + r.fullName + ")";
                        if (r.displayText.length >= 100) {
                            r.displayText = r.displayText.substring(0, 100) + "...";
                        }
                    }
                    return r;
                });
            }
            this.filteredStateRoutes.sort(function (a, b) {
                if (_this.sortJurisFirst) { //sort by juris first if enabled
                    var aJurisIndex = _this.jurisValues.indexOf(parseInt(a.juris, 10));
                    var bJurisIndex = _this.jurisValues.indexOf(parseInt(b.juris, 10));
                    if (aJurisIndex > bJurisIndex) {
                        return 1;
                    }
                    else if (aJurisIndex < bJurisIndex) {
                        return -1;
                    }
                }
                var aStr = a.displayText;
                var bStr = b.displayText;
                if (aStr.localeCompare(bStr) < 0) {
                    return -1;
                }
                else if (aStr.localeCompare(bStr) > 0) {
                    return 1;
                }
                return 0;
            });
        }
    };
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Boolean)
    ], RouteComponent.prototype, "jurisSort", void 0);
    tslib_1.__decorate([
        InputConverter(JSONConverter),
        tslib_1.__metadata("design:type", Array),
        tslib_1.__metadata("design:paramtypes", [Array])
    ], RouteComponent.prototype, "jurisValues", null);
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Boolean)
    ], RouteComponent.prototype, "showFullName", void 0);
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Boolean)
    ], RouteComponent.prototype, "hideRamps", void 0);
    return RouteComponent;
}(BaseComponent));
export { RouteComponent };
